/* eslint-disable */
import { Box, Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import React, { useState, useContext, useEffect } from 'react';
import { Formik } from 'formik';
import { ClientContext, useMutation, useQuery } from 'react-fetching-library';
import useMetadataUpdate from 'hooks/useMetadataUpdate';
import { useParams } from 'react-router';
import { compare } from 'fast-json-patch';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import ContentWrapper from '../../Wrappers/ContentWrapper';
import BackButton from '../../Shared/BackButton';
import RoundedButton from '../../Shared/RoundedButton';
import showServerError from '../../../helpers/showError';
import { AppRouteContext } from '../../../contexts';
import { ALL_ROUTES } from '../../../config/routes';
import {
  enqueueSnackbar,
  SNACKBAR_VARIANTS,
} from '../../../redux_store/reducer/reducers/notificationsReducer';
import ClaimForm from './widgets/ClaimForm';
import { checkPermission } from '../../../helpers/checkPermissions';
import permissions from '../../../config/permissions';
import { ActivePatientContext } from '../../../contexts/ActivePatientProvider';
import { object, string, array, number, addMethod } from 'yup';
import {
  addDays,
  getFormattedDate,
  getLocalizedDateIgnoreTime,
  getUtcDate,
} from '../../../helpers/localize';
import AutoFillingRule from './helpers';
import { BILLING_CLAIMS_STATUSES } from '../constants';
import Skeleton from '@material-ui/lab/Skeleton';
import { getTransitionWithVariable } from '../../../redux_store/reducer/reducers/i18nReducer';
import {
  INFO_PANE_PAGES,
  openInfoPane, toggleIsInfoPaneExpanded,
} from '../../../redux_store/reducer/reducers/infoPaneReducer';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PatientInfoBlock from '../../PatientDashboard/widgets/PatientInfoBlock';
import LoadingErrorWidget from '../../Shared/LoadingErrorWidget';
import { redirectUserToAllowedLink } from '../../../helpers/redirect';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
  },
  formCard: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    marginBottom: theme.spacing(10), // Space for actions
    margin: theme.spacing(3, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2, 0),
      borderRadius: 12,
    },
  },
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
  },
  formContent: {
    width: '100%',
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  actionsContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    padding: theme.spacing(3, 6),
    background: '#ffffff',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    boxShadow: '0 -4px 16px rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 4),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 2),
      gap: theme.spacing(1),
    },
  },
  actionButton: {
    textTransform: 'uppercase',
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    [theme.breakpoints.down('sm')]: {
      minWidth: 100,
      padding: theme.spacing(1, 2),
      fontSize: 13,
    },
  },
  backButton: {
    marginRight: 'auto',
  },
  additionInfo: {
    color: theme.colors.blue2,
    fontWeight: 400,
  },
  patientInfoContainer: {
    marginLeft: 6,
  },
  shimmer: {
    width: '100%',
    height: '100%',
  },
}));

const EditClaim = () => {
  const classes = useStyles();
  const { claimUuid, accountUuid, currentAccountUuid } = useParams();
  const { setAppRoute } = useContext(AppRouteContext);
  const {
    en: {
      titles,
      btn,
      errors,
      notifications,
      validationErrors,
      forms,
      infoPane,
    },
  } = useSelector((state) => state.i18n);
  const { currentPage } = useSelector((state) => state.infoPane);
  const [backendErrors, setBackendErrors] = useState({});
  const [initClaim, setInitClaim] = useState(null);
  const [claim, setClaim] = useState({});
  const [insuranceProviders, setInsuranceProviders] = useState(null);
  const [appointmentProviders, setAppointmentProviders] = useState(null);
  const [cptCodes, setCptCodes] = useState(null);
  const [modifiers, setModifiers] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [initActivities, setInitActivities] = useState([]);
  const dispatch = useDispatch();
  const { isSideMenuPinned, screenHeight } = useSelector((state) => state.appSettings);
  const [navWidth, setNavWidth] = useState(0);
  const params = useParams();
  const client = useContext(ClientContext);

  useEffect(() => {
    updateNavWidth().then(() => {
    });
  }, [isSideMenuPinned, screenHeight]);

  async function updateNavWidth() {
    for (let i = 5; i < 300; i += 5) {
      await new Promise(resolve => {
        setTimeout(() => {
          resolve('');
        }, i);
      });
      setNavWidth((window?.innerWidth ?? 1000) - (document.getElementById('navBar')?.getBoundingClientRect().width ?? 0) - 176);
    }
  }

  const {
    user,
    metadata: {
      currentAccount,
      currentAccountPermissions,
      childAccountPermissions,
    },
    isDistributionSponsor,
  } = useSelector((state) => state.user);
  const { patientInfo, setPatientInfo } = useContext(ActivePatientContext);

  const isClaimBelongsToCurrentAccount = !accountUuid && currentAccountUuid === currentAccount.uuid;

  const canEditClaim = isDistributionSponsor ? checkPermission(
    isClaimBelongsToCurrentAccount
      ? currentAccountPermissions
      : childAccountPermissions,
    permissions.CLAIM_PATCH,
  ) : false;

  const { query, loading: loadingClaim, error: getDataError } = useMetadataUpdate(useQuery, [
    {
      method: 'GET',
      endpoint: `/accounts/${accountUuid || currentAccount.uuid}/claims/${claimUuid}`,
    },
    false,
  ]);

  const { query: queryInfo, loading: loadingClaimInfo } = useMetadataUpdate(
    useQuery,
    [
      {
        method: 'GET',
        endpoint: `/accounts/${accountUuid || currentAccount.uuid}/patients/${
          claim && claim.patientUUID
        }/claims/lookup-info`,
      },
      false,
    ],
  );

  useEffect(() => {
    if (patientInfo) setPatientInfo(undefined);
  }, []);

  const getData = () => {
    query().then(({ error, payload }) => {
      if (!error) {
        const initActivities = AutoFillingRule.generateActivitiesUuid(payload);
        setInitActivities(initActivities);
        const newClaim = {
          ...payload,
          activities: initActivities,
          appointmentDate: payload.appointmentDate
            ? getLocalizedDateIgnoreTime(payload.appointmentDate, 'UTC')
            : new Date().toISOString(),
          checkDate: payload.checkDate
            ? getLocalizedDateIgnoreTime(payload.checkDate, 'UTC')
            : '',
          claimGeneratedTimestamp: payload.claimGeneratedTimestamp
            ? getLocalizedDateIgnoreTime(payload.claimGeneratedTimestamp, 'UTC')
            : '',
          entityOrderTimestamp: payload.entityOrderTimestamp
            ? getLocalizedDateIgnoreTime(payload.entityOrderTimestamp, 'UTC')
            : '',
          lastModifiedTimestamp: payload.lastModifiedTimestamp
            ? getLocalizedDateIgnoreTime(payload.lastModifiedTimestamp, 'UTC')
            : '',
          documentDate: payload.documentDate
            ? getLocalizedDateIgnoreTime(payload.documentDate, 'UTC')
            : payload.appointmentDate
              ? getLocalizedDateIgnoreTime(payload.appointmentDate, 'UTC')
              : new Date().toISOString(),
        };
        setClaim(newClaim);
        setInitClaim({
          ...payload,
          appointmentProvider: payload.appointmentProvider || initClaim && initClaim.appointmentProvider || null,
        });
      }
      // else {
      //   const { pathname } = location;
      //   redirectUserToAllowedLink(pathname, params, setAppRoute, client, 5)
      // }
    });
  };

  useEffect(() => {
    getData();
  }, [query]);

  useEffect(() => {
    if (queryInfo && claim && !insuranceProviders && claim.patientUUID) {
      queryInfo().then(({ error, payload }) => {
        if (!error) {
          if (payload.insuranceProviders) {
            const newInsuranceProviders = payload?.insuranceProviders?.filter((insurance) => !!insurance).map(
              (name) => {
                return {
                  label: name,
                  value: name,
                };
              },
            );
            setInsuranceProviders(newInsuranceProviders);
          }
          if (payload.appointmentProviders) {
            const newProviders = payload.appointmentProviders.filter((provider) => !!provider).map(
              (provider) => {
                return {
                  label: provider,
                  value: provider,
                };
              },
            );
            if (!claim.appointmentProvider && newProviders.length === 1) {
              setClaim({ ...claim, 'appointmentProvider': newProviders[0].value });
            }
            setAppointmentProviders(newProviders);
          }
          if (payload.cptCodes) {
            const newCptCodes = payload.cptCodes.map((name) => {
              return {
                label: name,
                value: name,
              };
            });
            setCptCodes(newCptCodes);
          }
          if (payload.modifiers) {
            const newModifiers = payload.modifiers.map((name) => {
              return {
                label: name,
                value: name,
              };
            });
            setModifiers(newModifiers);
          }
        }
      });
    }
  }, [queryInfo, claim]);

  const claimEditAction = (patches) => ({
    method: 'PATCH',
    endpoint: `/accounts/${accountUuid || currentAccount.uuid}/claims/${claimUuid}`,
    body: patches,
  });

  const { loading, mutate } = useMetadataUpdate(useMutation, [claimEditAction]);

  const editClaim = async () => {
    let formattedClaim = JSON.parse(JSON.stringify(claim));
    const activities = formattedClaim.billingStatus === BILLING_CLAIMS_STATUSES.insuranceIssue
      || formattedClaim.billingStatus === BILLING_CLAIMS_STATUSES.appointmentCancelled
      || formattedClaim.billingStatus === BILLING_CLAIMS_STATUSES.appointmentTypeIssue
      ? initActivities
      : formattedClaim.activities;

    const clearActivitiesIds = activities && activities.map((activity) => {
      const newActivity = { ...activity };
      delete newActivity.id;
      const pr = parseFloat(newActivity.pr);
      const paid = parseFloat(newActivity.paid);
      newActivity.allowed = (
        (!isNaN(pr) ? pr : 0) + (!isNaN(paid) ? paid : 0)
      ).toFixed(2);
      return newActivity;
    });

    const patches = compare(initClaim, {
      ...formattedClaim,
      activities: clearActivitiesIds,
    });

    if (patches.length) {
      setBackendErrors({});
      const { payload, error, status } = await mutate(patches);
      if (error) {
        setIsFailed(true);
        setTimeout(() => {
          setIsFailed(false);
        }, 2000);
        const options = payload && {
          correlationUUID: payload.correlationUUID,
          userUUID: user.uuid,
        };
        switch (status) {
          case 422: {
            showServerError(dispatch, errors.validationError);
            const parsedErrorList = {};
            Object.keys(payload.validationErrors).forEach((key) => {
              if (key.startsWith('activities') && key !== 'activities') {
                const newKey = key.substring(11, key.length - 1);
                parsedErrorList[formattedClaim.activities[newKey].id] =
                  payload.validationErrors[key];
              } else {
                parsedErrorList[key] = payload.validationErrors[key];
              }
            });
            setBackendErrors(parsedErrorList);
            break;
          }
          case 401: {
            showServerError(dispatch, notifications.notPermissionForEditingClaim);
            break;
          }
          default: {
            showServerError(dispatch, '', options);
            break;
          }
        }
      } else if (payload) {
        setIsSuccess(true);
        setTimeout(() => {
          setIsSuccess(false);
        }, 2000);
        setAppRoute({
          path: ALL_ROUTES.claim.list.path,
          title: ALL_ROUTES.claim.list.additional.title,
          clearBreadcrumbs: true,
          params: { currentAccountUuid: currentAccount.uuid },
        });
        dispatch(
          enqueueSnackbar({
            message: notifications.claimEdited,
            options: {
              variant: SNACKBAR_VARIANTS.success,
            },
          }),
        );
      }
    }
  };

  const isAllDataNotLoaded =
    !claim ||
    !Object.keys(claim) ||
    (!insuranceProviders || !cptCodes) ||
    loadingClaim ||
    loadingClaimInfo;

  addMethod(string, 'checkCPTCodes', function (errorMessage) {
    return this.test(`check-cpt-codes`, errorMessage, function (value) {
      const { path, createError } = this;
      if (!value) {
        return true;
      }
      const appointmentDate = claim.appointmentDate ? new Date(claim.appointmentDate) : new Date();
      const currentData = value ? new Date(value.includes('/') ? getUtcDate(value) : value) : null;
      const minDate = addDays(claim.appointmentDate ? new Date(claim.appointmentDate) : new Date(), -30);
      if (currentData < minDate) {
        return createError({
          path,
          message: getTransitionWithVariable(validationErrors.lessThan30days, {
            date: getFormattedDate(appointmentDate),
          }),
        });
      }
      const maxDate = addDays(claim.appointmentDate ? new Date(claim.appointmentDate) : new Date(), 30);
      if (currentData > maxDate) {
        return createError({
          path,
          message: getTransitionWithVariable(validationErrors.moreThan30days, {
            date: getFormattedDate(appointmentDate),
          }),
        });
      }
      return true;
    });
  });

  const CptSchema = object({
    code: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.cptCode,
    })),
    pr: number()
      .min(0, validationErrors.claimSumValueLimits)
      .max(5000, validationErrors.claimSumValueLimits),
    paid: number()
      .min(0, validationErrors.claimSumValueLimits)
      .max(5000, validationErrors.claimSumValueLimits),
    icd: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.icd,
    })),
    dos: string()
      .checkCPTCodes()
      .required(getTransitionWithVariable(validationErrors.requiredField, {
        fieldName: forms.icd,
      })),
    paymentDate: string().when('paid', {
      is: (paid) => paid > 0,
      then: () => string().required(getTransitionWithVariable(validationErrors.requiredField, {
        fieldName: forms.paymentDate,
      })),
      otherwise: () => string().notRequired(),
    }),
    prType: string().when('pr', {
      is: (pr) => pr > 0,
      then: () => string().required(validationErrors.PRTypeRequired),
      otherwise: () => string().notRequired(),
    }),
  });

  const ClaimsSchema = object({
    appointmentDate: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.appointmentTimestamp,
    })),
    insurance: string().when('billingStatus', {
      is: (billingStatus) => {
        return billingStatus !== BILLING_CLAIMS_STATUSES.insuranceIssue
          && billingStatus !== BILLING_CLAIMS_STATUSES.appointmentCancelled
          && billingStatus !== BILLING_CLAIMS_STATUSES.appointmentTypeIssue;
      },
      then: () => string().required(getTransitionWithVariable(validationErrors.requiredField, {
        fieldName: forms.insurance,
      })),
      otherwise: () => string().notRequired(),
    }),
    documentDate: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.documentDate,
    })),
    isPatientSeen: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.patientSeen,
    })),
    isDocumentUploaded: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.documentUploaded,
    })),
    billingStatus: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.billingStatus,
    })),
    location: string().required(getTransitionWithVariable(validationErrors.requiredField, {
      fieldName: forms.location,
    })),
    activities: claim.billingStatus === BILLING_CLAIMS_STATUSES.insuranceIssue
      || claim.billingStatus === BILLING_CLAIMS_STATUSES.appointmentCancelled
      || claim.billingStatus === BILLING_CLAIMS_STATUSES.appointmentTypeIssue
      ? null
      : array(CptSchema),
    claimStatus: string().when('billingStatus', {
      is: (billingStatus) => billingStatus === BILLING_CLAIMS_STATUSES.pending
        || billingStatus === BILLING_CLAIMS_STATUSES.hold,
      then: () => string().oneOf(['pending'], validationErrors.claimStatusMustBeEqual),
    }),
  });

  return (
    <>
      {getDataError && !loadingClaim ? <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}><LoadingErrorWidget onReload={getData} /></div> :
        <Formik
          initialValues={claim}
          validateOnBlur={false}
          enableReinitialize
          onSubmit={editClaim}
          validationSchema={ClaimsSchema}
        >
          {({ handleSubmit, errors }) => (
            <ContentWrapper
              titleText={titles.editClaim}
              additionalNode={
                (claim && claim.patientUUID) && (
                  <Grid
                    container
                    direction='column'
                    className={classes.patientInfoContainer}
                    style={{ width: 'auto' }}
                  >
                    <Typography
                      noWrap
                      className={cx(
                        classes.titleItem,
                        classes.titleText,
                        classes.additionInfo,
                      )}
                    >
                      {
                        loadingClaim || !Object.keys(claim)
                          ? <Skeleton variant='text' width={180} />
                          : claim.entityType === 'program'
                            ? <Box component='span' fontWeight='fontWeightMedium'>Program</Box>
                            : <>
                              <Box component='span' fontWeight='fontWeightMedium'>Assessment
                                name: </Box>
                              {claim.entityName}
                            </>
                      }
                    </Typography>
                    <Typography
                      noWrap
                      style={{ paddingBottom: 10 }}
                      className={cx(
                        classes.titleItem,
                        classes.titleText,
                        classes.additionInfo,
                      )}
                    >
                      {
                        loadingClaim || !Object.keys(claim)
                          ? <Skeleton variant='text' width={150} />
                          : <>
                            <Box component='span' fontWeight='fontWeightMedium'>MRN: </Box>
                            {claim.patientMrnNumber || '-'}
                          </>
                      }
                    </Typography>
                    <Grid container>
                      <PatientInfoBlock patientUUID={claim && claim.patientUUID}
                                        onSecondStyleClick={claim && claim.patientUUID ? (e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          const isPaneAlreadyOpenForThisInfo = ((currentPage?.currentPageContext?.patientUUID ?? currentPage?.currentPageContext?.uuid) === claim.patientUUID);
                                          if (currentPage?.currentPageName !== INFO_PANE_PAGES.patient_page || !isPaneAlreadyOpenForThisInfo) {
                                            dispatch(openInfoPane({
                                              currentPageName: INFO_PANE_PAGES.patient_page,
                                              currentPageContext: {
                                                ...patientInfo,
                                                uuid: claim.patientUUID,
                                                accountUUID: claim.accountUUID,
                                              },
                                            }));
                                          } else {
                                            dispatch(toggleIsInfoPaneExpanded(true));
                                          }
                                        } : null}
                      />
                    </Grid>
                  </Grid>
                )
              }
              containerStyle={{
                overflow: 'visible',
                maxHeight: 'calc(100% - 118px)',
                boxSizing: 'border-box',
                paddingBottom: 0,
              }}
            >
              <div className={classes.contentContainer}>
                <div className={classes.formCard}>
                  <div className={classes.scrollableContent}>
                    <div className={classes.formContent}>
                      <ClaimForm
                        isAllDataNotLoaded={isAllDataNotLoaded}
                        claim={claim}
                        setClaim={setClaim}
                        errors={errors}
                        initActivities={initActivities}
                        backendErrors={backendErrors}
                        setBackendErrors={setBackendErrors}
                        cptCodes={cptCodes}
                        modifiers={modifiers}
                        insuranceProviders={insuranceProviders}
                        appointmentProviders={appointmentProviders}
                        isDistributionSponsor={isDistributionSponsor}
                        navWidth={navWidth}
                      />
                    </div>
                  </div>
                </div>
                <div className={classes.actionsContainer}>
                  <BackButton className={classes.backButton} />
                  <RoundedButton
                    variant='contained'
                    color='primary'
                    disabled={loading || !canEditClaim}
                    onClick={handleSubmit}
                    isLoading={loading}
                    isSuccess={isSuccess}
                    isFailed={isFailed}
                    className={classes.actionButton}
                  >
                    {btn.save}
                  </RoundedButton>
                </div>
              </div>
            </ContentWrapper>
          )}
        </Formik>
      }
    </>
  );
};

EditClaim.propTypes = {};

export default EditClaim;
